import ky from 'ky'

// H1 後：access_token 走 HttpOnly cookie，前端不再讀寫 localStorage。
// localStorage 舊 token 在 store hydrate 時會被清掉（向後相容）。

let isRefreshing = false
let refreshPromise: Promise<boolean> | null = null

/** 嘗試用 refresh_token cookie 換新 access_token cookie；成功 true */
async function tryRefresh(): Promise<boolean> {
  if (isRefreshing) return refreshPromise!
  isRefreshing = true
  refreshPromise = (async () => {
    try {
      await ky.post('/api/auth/refresh', { credentials: 'same-origin' })
      return true
    } catch {
      return false
    } finally {
      isRefreshing = false
      refreshPromise = null
    }
  })()
  return refreshPromise
}

export const api = ky.create({
  prefix: window.location.origin,
  // include 確保跨 path cookie 都帶（access_token path=/, refresh_token path=/api/auth）
  credentials: 'include',
  hooks: {
    afterResponse: [
      async (request, _options, response) => {
        if (!response || response.status !== 401) return response
        // 401 可能是 access_token cookie 過期；用 refresh cookie 換新後重試
        const ok = await tryRefresh()
        if (!ok) {
          // 避免在 /login 自身 again 跳 /login
          if (!window.location.pathname.startsWith('/login')) {
            window.location.href = '/login'
          }
          return response
        }
        return ky(request)
      },
    ],
  },
})
